// extracted by mini-css-extract-plugin
export default {"link":"link_TRsPQ","cover":"cover_ijBPA","icon":"icon_w6yZj","content":"content_i6blA"};